<div class="contact-information-modal">
  <header class="modal__header">
    <h2>{{ "contact_form.label.check_your_information" | translate }}</h2>
    <a class="button button--transparent modal__button--close" (click)="closeModal()">
      <i class="icon icon-ui-close--sm"></i>
    </a>
  </header>
  <div class="modal__content">
    <air-form
      #formComponent
      [controls]="form"
      (submitted)="submitValues($event)"
      [showMandatory]="true"
      [disabled]="formDisabled"
      [showInvalidToast]="true"
      [userEventSource]="userEventSource"
    >
      <div class="modal__footer--full-width">
        <button
          type="button"
          (click)="submit($event)"
          class="button form__button button--cta"
          [airButtonLoading]="isSubmitting"
          [disabled]="formDisabled"
        >
          <span>{{ "general.label.send" | translate }}</span>
        </button>
      </div>
    </air-form>
  </div>
</div>
